import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import TopicsPage from './TopicsPage';
import { getCoursesForTopic, loadMoreCourses, resetCourses, setFilters } from 'store/courses/actions';
import { getProfileDetails } from 'store/profile/actions';
import { addCommonLoader, removeCommonLoader } from 'store/loader/actions';

const mapStateToProps = (state) => {
  return {
    tags: state.tags.tags,
    topics: state.topics.topics,
    courses: state.courses.courses.data,
    numberOfCourses: state.courses.courses.count,
    filters: state.courses.filters,
    profileTags: state.profile.details.tags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setFilters,
      resetCourses,
      getCoursesForTopic,
      loadMoreCoursesForTopic: loadMoreCourses,
      getProfileDetails,
      addCommonLoader,
      removeCommonLoader,
    },
    dispatch
  );
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TopicsPage);
